  export enum FinancialStatementsStatus {
    EXTRACT_DATA = "extrayendo-datos",
    ERROR_EXTRACT_DATA = "error-extrayendo-datos",
    IN_AGENT_REVIEW = "revision-agente",
    REQUEST_CREATION = "solicitud-en-creacion",
    ERROR_REQUEST_CREATION = "error-solicitud-en-creacion",
    REQUEST_COMPLETE = "solicitud-completa",
    IN_OPERATION_REVIEW = "revision-operaciones",
    VALIDACION_OPERACIONES ="validacion-operacion-en-proceso",
    ERROR_OPERATION = "error-revision-operaciones",
    CORRECT_INFO = "corregir-informacion",
    ERROR_CORRECT_INFO = "error-corregir-informacion",
    VALIDANDO_FIADO= "validando-fiado",
    ERROR_AGENT_REVIEW  =  "error-revision-agente",
    DUPLICATE_REQUEST = "solicitud-modificacion-duplicada",
    DUPLICATE_REQUEST_CURRENT_DOCUMENT = "solicitud-modificacion-documento-vigente",
    CANCELLED = "alta-cancelada",
    ERROR_CREATE_REQUEST = "error-creando-solicitud",
    IN_VALIDATION_PROCESS = "cotejo",
    IN_PROCESS = "ejecutando-validaciones"
  }
  
  export interface FinancialStatementsState {
    message: string;
    isError: boolean;
    color: string;
  }
  
  export const financialStatementsStates: Record<FinancialStatementsStatus, FinancialStatementsState> = {
    [FinancialStatementsStatus.EXTRACT_DATA]: { message: 'Extrayendo datos', isError: false, color: '#92D050' },
    [FinancialStatementsStatus.ERROR_EXTRACT_DATA]: { message: 'Error extrayendo datos', isError: true, color: '#FFC000' },
    [FinancialStatementsStatus.IN_AGENT_REVIEW]: { message: 'En proceso', isError: false, color: '#00B0F0' },
    [FinancialStatementsStatus.IN_PROCESS]: { message: 'En proceso', isError: false, color: '#00B0F0' },
    [FinancialStatementsStatus.REQUEST_CREATION]: { message: 'Creando solicitud', isError: false, color: '#E599F7' },
    [FinancialStatementsStatus.ERROR_REQUEST_CREATION]: { message: 'Error creando solicitud', isError: true, color: '#FF0000' },
    [FinancialStatementsStatus.REQUEST_COMPLETE]: { message: 'Solicitud completa', isError: false, color: '#92D050' },
    [FinancialStatementsStatus.IN_OPERATION_REVIEW]: { message: 'En revisión operaciones', isError: false, color: '#00B0F0' },
    [FinancialStatementsStatus.ERROR_OPERATION]: { message: 'Error revisión operaciones', isError: true, color: '#FF0000' },
    [FinancialStatementsStatus.CORRECT_INFO]: { message: 'Corregir', isError: false, color: '#0070C0' },
    [FinancialStatementsStatus.ERROR_CORRECT_INFO]: { message: 'Error al corregir', isError: true, color: '#FFC000' },
    [FinancialStatementsStatus.VALIDANDO_FIADO]: { message: 'Validando fiado', isError: false, color: '#92D050' },
    [FinancialStatementsStatus.VALIDACION_OPERACIONES]: { message: 'En revisión operaciones', isError: false, color: '#92D050' },
    [FinancialStatementsStatus.ERROR_AGENT_REVIEW]: { message: 'Error revisión agente', isError: true, color: '#FF0000' },
    [FinancialStatementsStatus.DUPLICATE_REQUEST]: { message: 'En proceso', isError: true, color: '#FF0000' },  
    [FinancialStatementsStatus.DUPLICATE_REQUEST_CURRENT_DOCUMENT]: { message: 'En proceso', isError: true, color: '#FF0000' },
    [FinancialStatementsStatus.CANCELLED]: { message: 'Solicitud cancelada', isError: false, color: '#92D050' },
    [FinancialStatementsStatus.ERROR_CREATE_REQUEST]: { message: 'Error creando solicitud', isError: true, color: '#FF0000' },
    [FinancialStatementsStatus.IN_VALIDATION_PROCESS]: {message: "En proceso", isError: false, color: '#92D050'}
  };
  
  export const completedFinancialStatementsStatus = [
    FinancialStatementsStatus.REQUEST_COMPLETE,
    FinancialStatementsStatus.ERROR_REQUEST_CREATION,
    FinancialStatementsStatus.IN_OPERATION_REVIEW,
    FinancialStatementsStatus.VALIDACION_OPERACIONES,
    FinancialStatementsStatus.DUPLICATE_REQUEST,
    FinancialStatementsStatus.ERROR_AGENT_REVIEW,
    FinancialStatementsStatus.DUPLICATE_REQUEST_CURRENT_DOCUMENT,
    FinancialStatementsStatus.ERROR_EXTRACT_DATA,
    FinancialStatementsStatus.ERROR_CREATE_REQUEST
  ]

  export const successFinancialStatementsStatus = [
    FinancialStatementsStatus.REQUEST_COMPLETE,
    FinancialStatementsStatus.IN_OPERATION_REVIEW,
    FinancialStatementsStatus.VALIDACION_OPERACIONES
  ]


  export const expedienteStates: Record<FinancialStatementsStatus, FinancialStatementsState> = {
    ...financialStatementsStates,
    [FinancialStatementsStatus.DUPLICATE_REQUEST]: { message: 'Solicitud duplicada', isError: true, color: '#92D050' },  
  };

  export const disableEstatusView = [FinancialStatementsStatus.REQUEST_CREATION];
  export const disableEstatus = [
    FinancialStatementsStatus.IN_PROCESS,
    FinancialStatementsStatus.IN_OPERATION_REVIEW,
    FinancialStatementsStatus.REQUEST_COMPLETE,
    FinancialStatementsStatus.VALIDACION_OPERACIONES,
    FinancialStatementsStatus.VALIDANDO_FIADO,
    FinancialStatementsStatus.REQUEST_CREATION,
    FinancialStatementsStatus.ERROR_REQUEST_CREATION
  ];

  export const isValidStatus = (status: FinancialStatementsStatus): boolean => {
    return !disableEstatus?.includes(status);
  }

  export const isValidStatusView = (status: FinancialStatementsStatus): boolean => {
    return !disableEstatusView?.includes(status);
  }

  export const controlChangeFinancialStatus = [
    FinancialStatementsStatus.EXTRACT_DATA,
    FinancialStatementsStatus.ERROR_EXTRACT_DATA,
    FinancialStatementsStatus.IN_AGENT_REVIEW,
    FinancialStatementsStatus.REQUEST_CREATION,
    FinancialStatementsStatus.ERROR_REQUEST_CREATION,
    FinancialStatementsStatus.CORRECT_INFO,
    FinancialStatementsStatus.ERROR_CORRECT_INFO,
    FinancialStatementsStatus.ERROR_AGENT_REVIEW,
    FinancialStatementsStatus.ERROR_CREATE_REQUEST,
    FinancialStatementsStatus.IN_VALIDATION_PROCESS,
  ];